

<div class="row ">
  <div class="col-12" style="overflow-x:auto;height:400px;">
    <ng2-smart-table [settings]="settings" class="tblscroll" [source]="source" (userRowSelect)="onRowSelect($event)"></ng2-smart-table>
  </div>
</div>




